module.exports = "/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved\n *\n * Licensed under CLOUD LINUX LICENSE AGREEMENT\n * http://cloudlinux.com/docs/LICENSE.TXT\n */\n:host /deep/ ui-simple-select > select {\n  width: 130px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/nodejs/application/application.component.less
// module id = 1209
// module chunks = 1